import { Routes } from '@angular/router';

export const routes: Routes = [
  // Default route — home is eager so first paint is instant (SSR pre-rendered)
  {
    path: '',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
    pathMatch: 'full',
  },

  // Main pages — lazy-loaded for code splitting
  {
    path: 'careers',
    loadComponent: () => import('./careers/careers.component').then(m => m.CareersComponent),
    title: 'Careers — ScriPay',
  },
  {
    path: 'about-us',
    loadComponent: () => import('./about-us/about-us.component').then(m => m.AboutUsComponent),
    title: 'About Us — ScriPay',
  },
  {
    path: 'products',
    loadComponent: () => import('./products/products.component').then(m => m.ProductsComponent),
    title: 'Products — ScriPay',
  },
  {
    path: 'contact-us',
    loadComponent: () => import('./contact-us/contact-us.component').then(m => m.ContactUsComponent),
    title: 'Contact Us — ScriPay',
  },

  // Policy pages — lazy loaded
  {
    path: 'cookie-policy',
    loadComponent: () => import('./cookie-policy/cookie-policy.component').then(m => m.CookiePolicyComponent),
    title: 'Cookie Policy — ScriPay',
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
    title: 'Privacy Policy — ScriPay',
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () => import('./terms-and-condition/terms-and-condition.component').then(m => m.TermsAndConditionComponent),
    title: 'Terms & Conditions — ScriPay',
  },

  // Wildcard (any unknown route)
  {
    path: '**',
    redirectTo: '',
  },
];